<template>
  <div>
    <anamnesis
      :modelList.sync="localModelList"
      v-bind="{
        ...schema,
        handleEvents,
        save,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'CAxACOxClarificationsPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    localModelList: [],
  }),

  watch: {
    modelList: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localModelList = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamCAxACOxClarifications', ['schema', 'modelList', 'status']),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamCAxACOxClarifications', [
      'fetchSchema',
      'fetchRecords',
      'saveRecords',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    async save() {
      try {
        const model = { modelList: this.localModelList };
        const action = 'saveRecords';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    handleEvents() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>

<style>
.placeholderColor input::placeholder {
  color: #616161 !important;
}
</style>
